/* import __COLOCATED_TEMPLATE__ from './simple-deploy-started.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Component from '@glimmer/component';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type SimpleDeployStarted from 'embercom/objects/inbox/renderable/simple-deploy-started';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type RouterService from '@ember/routing/router-service';
import type Session from 'embercom/services/session';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { type SafeString } from '@ember/template/-private/handlebars';

interface SimpleDeployStartedPart extends RenderablePart {
  renderableData: SimpleDeployStarted;
}

interface Args {
  part: SimpleDeployStartedPart;
}

interface Signature {
  Args: Args;
}

export default class Inbox2ConversationStreamEventPartsSimpleDeployStartedComponent extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare session: Session;

  targetRoute = 'apps.app.automation.fin-ai-agent.deploy.chat';

  get renderableData() {
    return this.args.part.renderableData;
  }

  get showLink() {
    return this.router.currentRouteName !== this.targetRoute;
  }

  get linkHtml(): SafeString {
    if (this.showLink) {
      return sanitizeHtml(
        `<a href="${this.router.urlFor(this.targetRoute, { app_id: this.session.workspace.id })}" class="no-underline hover:text-link" data-test-simple-deploy-link>${this.intl.t('inbox.event-group.simple-deploy-started.link-text')}</a>`,
      );
    } else {
      return sanitizeHtml(
        `<span data-test-simple-deploy-text>${this.intl.t('inbox.event-group.simple-deploy-started.link-text')}</span>`,
      );
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::SimpleDeployStarted': typeof Inbox2ConversationStreamEventPartsSimpleDeployStartedComponent;
    'inbox2/conversation-stream/event-parts/simple-deploy-started': typeof Inbox2ConversationStreamEventPartsSimpleDeployStartedComponent;
  }
}
